import "./component-library198.mjs";
import normalizeComponent from "./component-library91.mjs";
const _sfc_main = {
  name: "ComparisonTableSlide"
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "comparison-table-slide" }, [_vm._t("default")], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "a963adc9",
  null,
  null
);
const ComparisonTableSlide = __component__.exports;
export {
  ComparisonTableSlide as default
};
